import type { ScopeSourceDefinition } from '@shared/lib/scope'
import type { ScopeMode, ScopeStatus } from '@shared/lib/scope'

interface SourceVisit {
  changed: boolean
  isSamePage: boolean
}

export const sourceStartMode = (
  definition: Pick<ScopeSourceDefinition, 'keepOnRevisit'>,
  status: ScopeStatus,
  { changed, isSamePage }: SourceVisit,
): ScopeMode | null => {
  if (changed || status === 'idle' || status === 'error') return 'enter'
  if (status === 'loading' || isSamePage) return null

  return definition.keepOnRevisit ? 'refresh' : 'enter'
}
